<div class="p-grid">
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">EmailTemplate Id</div>
        {{emailTemplateDetail?.templateId}}
    </div>
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">Email Template Name</div>
        {{emailTemplateDetail?.templateName}}
    </div>
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">Screen Name</div>
        {{emailTemplateDetail?.screenName}}
    </div>
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">Subject</div>
        {{emailTemplateDetail?.subject}}
    </div>
</div>

<div class="p-grid">
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">Is Active</div>{{emailTemplateDetail?.isActive}}
    </div>
</div>

